import React, { useState } from "react";
import HeroLayout from "../components/HeroLayout";


const images = require.context("../assets/images", false);

const faqs = [
  {
    question: "1. What is a Golden Triangle Tour?",
    answer:
      "A Golden Triangle Tour connects India's three most iconic cities - Delhi, Agra, and Jaipur - forming a triangle on the map. It showcases the best of India's history, architecture, and culture, from the Taj Mahal to Mughal forts and royal Rajput palaces. Luxury Golden Triangle curates this journey into an unforgettable private experience."
  },
  {
    question: '2. Is "Golden Triangle Tour" and "Golden Triangle India" the same?',
    answer:
      "Yes, both terms refer to the same iconic travel circuit covering Delhi, Agra, and Jaipur in northern India. Whether you search for a Golden Triangle Tour or Golden Triangle India, the destination and experience remain the same. Itineraries under both names are tailored entirely to your preferences and travel style."
  },
  {
    question: "3. How many days are ideal for a Golden Triangle Tour?",
    answer:
      "A minimum of 5 to 6 days is recommended to comfortably explore Delhi, Agra, and Jaipur without feeling rushed. For a truly immersive experience, 7 to 8 days allows deeper cultural exploration and leisure time. Flexible itineraries can be designed to perfectly suit your schedule."
  },
  {
    question:
      "4. Is the Golden Triangle Tour suitable for couples, families, solo women, and business travellers?",
    answer:
      "Absolutely - the Golden Triangle Tour is one of India's most versatile itineraries, welcoming all types of travellers. Every journey is thoughtfully crafted whether it's a romantic escape, a family adventure, a solo women's trip, or a corporate retreat. Comfort, safety, and style remain the priority across every experience."
  },
  {
    question: "5. Which is the best tour company for a Luxury Golden Triangle Tour?",
    answer:
      "Luxury Golden Triangle stands out as the premier choice for private, high-end Golden Triangle Tours in India. With expertly curated itineraries, handpicked luxury hotels, and dedicated personal guides, every detail is executed to perfection. Their deep expertise and personalized service make them the most trusted name in luxury India travel."
  },
  {
    question: "6. What is the best time to visit on a Golden Triangle Tour?",
    answer:
      "The ideal time to explore the Golden Triangle is from October to March, when the weather is pleasant and perfect for sightseeing. This window offers the most comfortable and enjoyable experience across Delhi, Agra, and Jaipur. That said, a seamless journey can be ensured regardless of the season you choose to travel."
  },
  {
    question:
      "7. Why is Luxury Golden Triangle the best Indian travel company for private luxury Golden Triangle Tours?",
    answer:
      "Luxury Golden Triangle combines decades of expertise with an unwavering commitment to personalized, white-glove service on every tour. From exclusive heritage hotel stays to private guided experiences at iconic monuments, every element is curated to the highest standard. Their passion for authentic luxury travel makes them India's most distinguished Golden Triangle tour operator."
  },
  {
    question: "8. What are the best extensions to a Golden Triangle Tour if I have 3-4 extra days?",
    answer:
      "With additional days, popular extensions include Ranthambore for a thrilling tiger safari, Varanasi for a spiritual experience on the Ganges, or Udaipur for its breathtaking lake palaces. Each extension can be seamlessly woven into your existing itinerary for a fluid, enriching experience. The right add-on depends entirely on your interests and travel pace."
  }
];

function Faq() {
  const [openIndex, setOpenIndex] = useState(0);
  
  return (
         <>
        <HeroLayout>
    <div
        className="banner-bg bg-top"
        style={{
            backgroundImage:
            `linear-gradient(#370b2e66, #370b2e66), url(${images("./rff.webp")})`
        }}
        >
        <div className="container">
            <div className="inner-banner-content full-width center color-white mt-5">
            <h1>Frequently Asked Questions</h1>
            </div>
        </div>
        </div>

    </HeroLayout>
    <main className="faq-page paddingY-70">
      <div className="container">
        <div className="heading center">
          <h2>Frequently Asked Questions</h2>
          <p>Helpful answers for planning your Luxury Golden Triangle journey.</p>
        </div>
        <div className="faq-accordion">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div className={`faq-item ${isOpen ? "active" : ""}`} key={faq.question}>
                <button
                  aria-controls={`faq-answer-${index}`}
                  aria-expanded={isOpen}
                  className="faq-question"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  type="button"
                >
                  <span>{faq.question}</span>
                  <span aria-hidden="true" className="faq-icon">{isOpen ? "-" : "+"}</span>
                </button>
                <div
                  className="faq-answer"
                  hidden={!isOpen}
                  id={`faq-answer-${index}`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </main>
    </>
  );
}

export default Faq;
